import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <SectionWrapper data-id="element-107">
      <div className="max-w-3xl mx-auto bg-card-bg border-2 border-gold/30 rounded-3xl p-8 md:p-12 text-center shadow-lg relative overflow-hidden" data-id="element-108">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold/40 via-gold to-gold/40" data-id="element-109"></div>

        <div className="inline-flex items-center justify-center w-24 h-24 bg-gold/10 rounded-full mb-8" data-id="element-110">
          <ShieldCheck size={48} className="text-gold" data-id="element-111" />
        </div>

        <h2 className="text-3xl md:text-4xl font-black text-burgundy mb-8 tracking-wide" data-id="element-112">
          GARANTÍA CÓDIGO HIJO — 7 DÍAS
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-text-main/80 font-medium leading-relaxed" data-id="element-113">
          <p data-id="element-114">
            Abrís los 6 tomos. Revisás los 3 bonus.{' '}
            <br className="hidden md:block" data-id="element-115" />
            Los aplicás con tu hijo si querés.
          </p>

          <p className="font-bold text-burgundy text-2xl py-4" data-id="element-116">
            Si en 7 días no es lo que esperabas:
            <br data-id="element-117" />
            Te devolvemos el 100%.
          </p>

          <p data-id="element-118">Sin preguntas. Sin formularios. Sin drama.</p>

          <div className="w-16 h-px bg-dusty-rose/30 mx-auto my-8" data-id="element-119"></div>

          <p className="text-base text-text-main/60 italic" data-id="element-120">
            La confianza que tenemos en Código Hijo nos permite hacer esa
            promesa sin dudar. Más de 500 mamás de toda Latinoamérica ya lo
            saben. La tasa de devoluciones es menor al 1%.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}